import styled from "styled-components";

export const Container = styled.div`
  /* left: calc(50% - 360px / 2);
top: calc(50% - 176px / 2 - 75px); */

  margin: 0 auto;
  padding: 20px 0;
  box-sizing: border-box;
`;
export const Category = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  & div {
    font-weight: 400;
    font-size: 12px;
    letter-spacing: -0.02em;
    padding: 1px 4px;
    flex: none;
    order: 0;
    flex-grow: 0;

    &.category {
      background: #f1f3f5;
      border-radius: 4px;
      text-align: center;
    }

    &.createAt {
      color: #aeb5bc;
      padding-right: 0;
    }
  }
`;

export const Content = styled.div`
  color: #222529;
  font-size: 14px;
  letter-spacing: -0.01em;
  margin-bottom: 16px;

  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
`;

export const Aside = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  font-size: 12px;
  letter-spacing: -0.02em;

  & .nickName {
    font-weight: 500;
    color: #4a5056;
  }

  & .aside__icons {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #878e95;

    & .likedNumber {
      margin-right: 8px;
      font-size: 12px;
      margin-left: 2px;
    }

    & div {
      font-size: 12px;
      margin-left: 2px;
    }

    & .likedDiv {
      margin-right: 6px;
      cursor: pointer;

      & img {
        height: 13.506841659545898px;
        width: 15.000017166137695px;
      }
    }

    & .orange {
      /* isLiked=true */
      color: #ff7a00;
      font-weight: 600;
      font-size: 12px;
      line-height: 20px;
    }
    & .balck {
      /* isLiked=false */
      font-size: 12px;
      line-height: 20px;
      color: #878e95;
    }

    &.commentsDiv {
      & .comments {
        height: 14.603842735290527px;
        width: 14.166666030883789px;
      }
    }
  }
`;

export const Embedded = styled.div`
  width: 100%;
  height: 80px;
  border: 1px solid #f1f3f5;
  border-radius: 8px;
  margin-top: 20px;
  margin-bottom: 20px;
  overflow: hidden;

  box-sizing: border-box;

  & a {
    height: 100%;
  }

  & article {
    display: flex;
    flex-wrap: nowrap;

    position: relative;
  }

  & main {
    width: 59%;
    height: 60px;
    margin: 10px 12px;

    box-sizing: border-box;

    overflow: hidden;
  }

  & h1 {
    color: #000;
    font-size: 13px;
    line-height: 20px;
    margin-bottom: 3px;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & div {
    display: inline-flex;
    overflow: hidden;

    width: 100%;
  }

  & p {
    //height: 45%;
    color: #878e95;
    font-size: 12px;
    line-height: 18px;

    overflow: hidden;
    text-overflow: ellipsis;

    display: -webkit-box;
    -webkit-line-clamp: 2; /* 라인수 */
    -webkit-box-orient: vertical;
    word-break: break-word;
    line-height: 18px;
    height: 18px * 2;
  }

  & span {
  }

  & img {
    //background-color: #f1f3f5;
    //object-fit: contain;
    object-fit: fill;
    width: 33%;
    height: 100%;
    position: absolute;
    right: 0;
    border-left: 1px solid #f1f3f5;
  }
`;
